import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import "@/core/plugins/prismjs";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as directives from "vuetify/directives";
import * as components from "vuetify/components";
import "@mdi/font/css/materialdesignicons.css";
import { aliases, mdi } from "vuetify/iconsets/mdi";

const myCustomLightTheme = {
  dark: false,
  colors: {
    background: "#235153",
    surface: "#235153",
    primary: "#e9dc17",
    "primary-darken-1": "#c0b510",
    secondary: "#03DAC6",
    "secondary-darken-1": "#018786",
    error: "#ef3356",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
  },
  light: {
    primary: "#e9dc17",
  },
};
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "myCustomLightTheme",
    themes: {
      myCustomLightTheme,
    },
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  defaults: {
    global: {},
    VTextField: {
      variant: "outlined",
      color: "primary",
      density: "compact",
    },
    VAutocomplete: {
      variant: "outlined",
      color: "primary",
      density: "compact",
    },
    VSelect: {
      variant: "outlined",
      color: "primary",
      density: "compact",
    },
    VCheckbox: {
      color: "primary",
    },
    VRadio: {
      color: "primary",
    },
  },
});
const app = createApp(App);
app.use(store);
app.use(router);

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.use(vuetify).mount("#app");
